import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { CustomizableButtonComponent } from '../ui/customizable-button/customizable-button.component';

@Component({
  selector: 'message-submit-button',
  standalone: true,
  imports: [CustomizableButtonComponent],
  templateUrl: './message-submit-button.html',
  styleUrls: ['./message-submit-button.css'],
})
export class MessageSubmitButton {
  @Input() loading: boolean = false;
  @Input() disabled: boolean = false;

  @Input() cancelAction: () => void = () => {};
  @Output() cancel = new EventEmitter<void>();

  onCancel() {
    this.cancel.emit();
    this.cancelAction();
  }
}
